import { useState } from 'react';
import { Box, Button, useTheme, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useTranslation } from 'react-i18next';
import { useLocation, Link } from 'react-router-dom';
import { locations } from 'services/routes/locations';
import { useQueryParams } from 'services/hooks';
import FormContainer from 'pages/FormContainer';
import FormHeader from 'pages/FormContainer/components/FormHeader';
import { ResetPasswordForm, NewPasswordForm } from './components';

const ResetPassword = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const location = useLocation();
  const { getQueryParams } = useQueryParams();
  const [isRequestSuccessful, setIsRequestSuccessful] = useState(false);

  const queryParams = getQueryParams(location.search);

  const handleSuccessfulRequest = () => setIsRequestSuccessful(true);

  if (queryParams.token) {
    return (
      <FormContainer>
        <Box data-testid="container">
          {!isRequestSuccessful ? (
            <>
              <FormHeader
                title={t('auth:reset')}
                description={t('auth:newPasswordText')}
              />

              <NewPasswordForm
                onSuccess={handleSuccessfulRequest}
                // @ts-ignore
                token={queryParams.token}
              />
            </>
          ) : (
            <>
              <FormHeader title={t('auth:newPasswordSuccessText')} />
              <Button
                component={Link}
                to={locations.general.login.pathname}
                color="primary"
                variant="rounded"
                sx={{
                  maxWidth: theme.spacing(50),
                  marginBottom: theme.spacing(5),
                  height: theme.spacing(5),
                }}
              >
                {t('auth:backToLogin')}
              </Button>
            </>
          )}
        </Box>
      </FormContainer>
    );
  }

  return (
    <FormContainer>
      <Box data-testid="container" sx={{ width: '100%' }}>
        <FormHeader
          title={t('auth:forgot')}
          description={t('auth:resetPasswordText')}
        />

        {!isRequestSuccessful ? (
          <>
            <ResetPasswordForm onSuccess={handleSuccessfulRequest} />
            <Typography
              variant="body1"
              component={Link}
              to={locations.general.login.pathname}
              align="center"
              color="textSecondary"
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <ArrowBackIcon sx={{ mr: theme.spacing(1) }} />{' '}
              {t('auth:backToLogin')}
            </Typography>
          </>
        ) : (
          <>
            <Typography
              variant="body1"
              align="left"
              sx={{
                maxWidth: 390,
                marginBottom: theme.spacing(3),
              }}
            >
              {t('auth:checkEmailText')}
            </Typography>
            <Button
              component={Link}
              to={locations.general.login.pathname}
              color="primary"
              variant="rounded"
              sx={{
                maxWidth: theme.spacing(50),
                marginBottom: theme.spacing(5),
                height: theme.spacing(5),
              }}
              fullWidth
            >
              {t('auth:backToLogin')}
            </Button>
          </>
        )}
      </Box>
    </FormContainer>
  );
};

export default ResetPassword;
